// React import
import React from 'react';
// Styles imports
import './TokenAnalyzerAiStats.css';
import '../../util.css'

class TokenAnalyzerAiStats extends React.Component {

    render () {
        return(
            <div className={"token-analyzer__ai-stats-block"}>
                <span className={"token-analyzer__ai-stats-text"}>
                    AI features<br/>coming soon
                </span>
            </div>
        );
    }

}

export default TokenAnalyzerAiStats;